/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { useDispatch, useSelector } from 'react-redux';
import {
  dispatchGenerateInvoiceCriteriaList,
  setGenerateInvoiceDetailTab,
} from '../../store/Actions';

export default (props) => {
  const dispatch = useDispatch();
  // use Selector function
  const detailScreenTabData = useSelector(
    (state) => state.sharedState.GenerateInvoiceReducer?.generateInvDetailTabObj
  );
  const generateInvoiceGridData = useSelector((state) =>
    state.sharedState.GenerateInvoiceReducer?.generateInvoiceGridVOList?.sort(
      (a, b) => a.cfSortKey - b.cfSortKey
    )
  );
  const { value, column, data } = props;
  let rowIndex = 0;
  rowIndex = generateInvoiceGridData.findIndex((x) => {
    return x.id === props?.data?.id;
  });
  // handing onClick event & check validation on filed level
  const handleOnClickEvent = (e) => {
    const newObj = [...generateInvoiceGridData];
    newObj[rowIndex][props?.column.colId] =
      parseInt(value, [0, 1]) === 0 ? 1 : 0;
    props.node.setDataValue(
      props?.column.colId,
      parseInt(value, [0, 1]) === 0 ? 1 : 0
    );
    dispatch(dispatchGenerateInvoiceCriteriaList(newObj));
    dispatch(
      setGenerateInvoiceDetailTab({
        ...detailScreenTabData,
        disabledSaveCancelBtn: false,
        successMessages: [],
        errorMessages: [],
      })
    );
  };
  // handle on change event
  const handleOnChange = () => {
    return null;
  };
  const BLUE_COLOR_CODE = '16756655';
  const getBgFieldForCol = (colId) => {
    switch (colId) {
      case 'printImageInd':
        return 'cfPrintImage';
      case 'defPaperInd':
        return 'cfPrint';
      case 'defCmsElectInd':
        return 'cfCmsElect';
      case 'defNcpdpSummaryInd':
        return 'cfNcpdpSumm';
      case 'defNcpdpClaimOwnInd':
        return 'cfNcpdpClaimOwn';
      case 'defNcpdpClaimMbInd':
        return 'cfNcpdpClaimMb';
      default:
        return null;
    }
  };
  const isBlueBackground = (coloumnData,dataTop) => {
    const bgField = getBgFieldForCol(coloumnData);
    if (!bgField) return false;
    const val = dataTop?.[bgField];
    return val !== undefined && val !== null && val.toString() === BLUE_COLOR_CODE;
  };

  const whiteIconProps = {
    icon: <CheckBoxOutlineBlankIcon style={{ color: '#ffffff' }} />,
    checkedIcon: <CheckBoxIcon style={{ color: '#ffffff' }} />,
  };
  if (column.colId === 'defPaperInd') {
    return (
      <>
        <div
          className="tbl-checkbox frr-checkbox-no-label"
          data-testid="checkbox-com"
        >
          <FormControlLabel
            label="check"
            data-testid="common-chk"
            control={<Checkbox color="primary" {...(isBlueBackground('defPaperInd',data) ? whiteIconProps : {})}  />}
            checked={parseInt(value, [0, 1]) === 1}
            value={parseInt(value, [0, 1]) === 1}
            onClick={(e) => {
              if (e.target.checked !== undefined) {
                handleOnClickEvent(e);
              }
            }}
          />
        </div>
      </>
    );
  }
  if (column.colId === 'printImageInd') {
    return (
      <>
        <div
          className="tbl-checkbox frr-checkbox-no-label"
          data-testid="checkbox-com"
        >
          <FormControlLabel
            label="check"
            data-testid="common-chk"
            control={<Checkbox color="primary"  {...(isBlueBackground('printImageInd',data) ? whiteIconProps : {})} />}
            checked={parseInt(value, [0, 1]) === 1}
            value={parseInt(value, [0, 1]) === 1}
            disabled={
              detailScreenTabData?.state?.actionType !== 1 &&
              data?.printImageCreateDt === null
            }
            onClick={(e) => {
              if (
                detailScreenTabData?.state?.actionType !== 1 &&
                data?.printImageCreateDt === null
              ) {
                handleOnChange();
              } else if (e.target.checked !== undefined) {
                handleOnClickEvent(e);
              }
            }}
          />
        </div>
      </>
    );
  }
  if (column.colId === 'defCmsElectInd') {
    return (
      <>
        <div
          className="tbl-checkbox frr-checkbox-no-label"
          data-testid="checkbox-com"
        >
          <FormControlLabel
            label="check"
            data-testid="common-chk"
            control={<Checkbox color="primary" {...(isBlueBackground('defCmsElectInd',data) ? whiteIconProps : {})}     />}
            checked={parseInt(value, [0, 1]) === 1}
            value={parseInt(value, [0, 1]) === 1}
            disabled={
              detailScreenTabData?.state?.actionType !== 1 &&
              data?.cmsElectCreateDt === null
            }
            onClick={(e) => {
              if (
                detailScreenTabData?.state?.actionType !== 1 &&
                data?.cmsElectCreateDt === null
              ) {
                handleOnChange();
              } else if (e.target.checked !== undefined) {
                handleOnClickEvent(e);
              }
            }}
          />
        </div>
      </>
    );
  }
  if (column.colId === 'defNcpdpSummaryInd') {
    return (
      <>
        <div
          className="tbl-checkbox frr-checkbox-no-label"
          data-testid="checkbox-com"
        >
          <FormControlLabel
            label="check"
            data-testid="common-chk"
            control={<Checkbox color="primary" {...(isBlueBackground('defNcpdpSummaryInd',data) ? whiteIconProps : {})}  />}
            checked={parseInt(value, [0, 1]) === 1}
            value={parseInt(value, [0, 1]) === 1}
            disabled={
              detailScreenTabData?.state?.actionType !== 1 &&
              data?.ncpdpSummaryCreateDt === null
            }
            onClick={(e) => {
              if (
                detailScreenTabData?.state?.actionType !== 1 &&
                data?.ncpdpSummaryCreateDt === null
              ) {
                handleOnChange();
              } else if (e.target.checked !== undefined) {
                handleOnClickEvent(e);
              }
            }}
          />
        </div>
      </>
    );
  }
  if (column.colId === 'defNcpdpClaimOwnInd') {
    return (
      <>
        <div
          className="tbl-checkbox frr-checkbox-no-label"
          data-testid="checkbox-com"
        >
          <FormControlLabel
            label="check"
            data-testid="common-chk"
            control={<Checkbox color="primary" {...(isBlueBackground('defNcpdpClaimOwnInd',data) ? whiteIconProps : {})}  />}
            checked={parseInt(value, [0, 1]) === 1}
            value={parseInt(value, [0, 1]) === 1}
            disabled={
              detailScreenTabData?.state?.actionType !== 1 &&
              data?.ncpdpClaimOwnCreateDt === null
            }
            onClick={(e) => {
              if (
                detailScreenTabData?.state?.actionType !== 1 &&
                data?.ncpdpClaimOwnCreateDt === null
              ) {
                handleOnChange();
              } else if (e.target.checked !== undefined) {
                handleOnClickEvent(e);
              }
            }}
          />
        </div>
      </>
    );
  }
  if (column.colId === 'defNcpdpClaimMbInd') {
    return (
      <>
        <div
          className="tbl-checkbox frr-checkbox-no-label"
          data-testid="checkbox-com"
        >
          <FormControlLabel
            label="check"
            data-testid="common-chk"
            control={<Checkbox color="primary" {...(isBlueBackground('defNcpdpClaimMbInd',data) ? whiteIconProps : {})}/>}
            checked={parseInt(value, [0, 1]) === 1}
            value={parseInt(value, [0, 1]) === 1}
            disabled={
              detailScreenTabData?.state?.actionType === 1 ||
              (detailScreenTabData?.state?.actionType !== 1 &&
                data?.ncpdpClaimMbCreateDt === null)
            }
            onClick={(e) => {
              if (
                detailScreenTabData?.state?.actionType !== 1 &&
                data?.ncpdpClaimMbCreateDt === null
              ) {
                handleOnChange();
              } else if (e.target.checked !== undefined) {
                handleOnClickEvent(e);
              }
            }}
          />
        </div>
      </>
    );
  }
  return '';
};
